export default {"src":"/_next/static/media/full-screen.60285e2d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};